export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img src="img/logo.png" style={{height: 80, marginTop: -30}}/>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href="tel:+74722411213">+7 (4722) 41-12-13</a>
            </li>
            <li>
              <a href='#features' className='page-scroll'>
                Преимущества
              </a>
            </li>
            <li>
              <a href='#about' className='page-scroll'>
                Арендаторам
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
                Галерея
              </a>
            </li>
            <li>
              <a href='#yamap' className='page-scroll'>
                Карта
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Связаться с нами
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
